import React, { useState } from 'react';
import { Dropdown, Form } from 'semantic-ui-react';
import { SettleDocument } from 'src/graphql/documents';
import { useDispatch } from 'react-redux';
import { importAlertState } from 'src/redux/actions/alert';
import { importUpdateCashflowNeeded } from 'src/redux/actions/flujocaja';
import { updateConcilieantionRatio } from 'src/redux/actions/dashboard';
import { setUpdateDocuments } from 'src/redux/actions/documentostributarios';
import { importUpdateNominaInProcessNeeded } from 'src/redux/actions/proveedores';
import CustomModal from '../../configuracion/components/customModal';
import { useBlockedFeatures } from 'src/hooks/useBlockedFeatures';

export const PayoffModal = ({ companyId, option, selected }) => {
    const dispatch = useDispatch();
    const { isAbonarBlocked } = useBlockedFeatures();
    const [open, setOpen] = useState(false);
    const today = new Date().toISOString().split("T")[0]
    const [dateToSettle, setDateToSettle] = useState(today);
    const handleOpen = () => {
        if (isAbonarBlocked()) {
            dispatch(importAlertState({
                content: 'La función "Abonar" está bloqueada para tu cuenta.',
                state: 'warning',
                duration: 4,
            }));
            return;
        }
        setOpen(true);
    };
    const handleClose = () => setOpen(false);
    
    const { executeMutation } = SettleDocument()

    const handleSubmit = async () => {
        try {
            const input = selected.map((document) => ({ 
                id: document.id || document._id, 
                amount: document.meta?.remaining || document?.amount, 
                date: dateToSettle 
            }))
            const { data, error } = await executeMutation({ companyId, input })

            handleClose();

            if (error || data?.settleDocument?.nModified === 0) {
                return dispatch(
                    importAlertState({
                      content: "Error al saldar, intente nuevamente.",
                      state: "error",
                      duration: 3,
                    })
                  )
            }

            dispatch(importUpdateNominaInProcessNeeded({ value: true }))
            dispatch(importUpdateCashflowNeeded({ value: true, reload: null }))
            dispatch(updateConcilieantionRatio());
            dispatch(setUpdateDocuments({ value: true }))

            dispatch(
                importAlertState({
                  content: selected.length > 1 ? "Documentos saldados con éxito" : "Documento saldado con éxito",
                  state: "success",
                  duration: 3,
                })
              )
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <>
            <Dropdown.Item value={option?.value} onClick={handleOpen}>
                {option?.text}
            </Dropdown.Item>
            <CustomModal
                open={open}
                onClose={handleClose}
                dimmer="blurring"
                size="tiny"
                title="Saldar documento"
                confirmLabel="Sí, saldar"
                onConfirm={handleSubmit}
                content={
                    <>
                        <p>
                      { selected?.length > 0 
                          ? `Va a saldar manualmente ${selected?.length} ${selected?.length == 1 ? 'documento' : 'documentos'}`
                          : `Va a saldar manualmente este documento` }
                        </p>
                    <Form.Input
                        label="¿Con qué fecha de pago debiera saldarse?"
                        type="date"
                        placeholder="Ingrese su Correo"
                        name="date"
                        onChange={(_, v) => setDateToSettle(v.value)}
                        className="w-100 mt-4"
                        fluid
                        defaultValue={today} 
                    />
                    </>
                }
            />
        </>
    );
};
